import { Sidebar, SidebarContent } from '@/shared/ui/sidebar';
import MockSidebar from '../../components/sidebar/MockSidebar';
import { useSelector } from 'react-redux';
import { getCurrentMock } from '../../selectors/mockSelectors';

/**
 * Wraps the legacy MockSidebar inside the shadcn Sidebar component.
 * Uses collapsible="offcanvas" so it renders as a Sheet on mobile.
 * No collapse button — always expanded on desktop.
 */
export function MockSidebarShell() {
  const mock = useSelector((s: unknown) => getCurrentMock(s as never));

  return (
    <Sidebar collapsible="offcanvas" className="border-r">
      <SidebarContent className="overflow-y-auto">
        <MockSidebar mock={mock} />
      </SidebarContent>
    </Sidebar>
  );
}
